import React, { useState, useEffect } from 'react';
import './Header.css';

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleNavClick = (e, page) => {
    e.preventDefault();
    closeMobileMenu();
    window.navigateTo && window.navigateTo(page);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="header-logo" onClick={() => { closeMobileMenu(); window.navigateTo && window.navigateTo('landing'); }}>
          <h1>
            <span className="logo-pak">Pak</span>
            <span className="logo-milkiyat">Milkiy<small className='logo-icon'>🏡</small>t</span>
          </h1>
        </div>

        <nav className={`header-nav ${isMobileMenuOpen ? 'active' : ''}`}>
          <a href="#home" className="nav-link" onClick={(e) => handleNavClick(e, 'landing')}>Home</a>
          <a href="#buy" className="nav-link" onClick={(e) => handleNavClick(e, 'listings')}>Buy</a>
          <a href="#rent" className="nav-link" onClick={(e) => handleNavClick(e, 'rent')}>Rent</a>
          <a href="#projects" className="nav-link" onClick={(e) => handleNavClick(e, 'projects')}>Projects</a>
          <a href="#agents" className="nav-link" onClick={(e) => handleNavClick(e, 'agents')}>Agents</a>
          <a href="#blogs" className="nav-link" onClick={(e) => handleNavClick(e, 'blogs')}>Blogs</a>
          <a href="#contact" className="nav-link" onClick={(e) => handleNavClick(e, 'contact')}>Contact</a>
        </nav>

        <div className="header-actions">
          <button className="btn-post" onClick={() => window.navigateTo && window.navigateTo('sell-property')}>Post Property</button>
          <button className="btn-login" onClick={() => window.navigateTo && window.navigateTo('login')}>Login</button>
        </div>

        <button className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
}

export default Header;
